import React from "react";
import { CheckCircle } from "@phosphor-icons/react";

/**
 * Blue tick verification badge. Filled gold-checkmark variant per Jamaican theme.
 * Sizes: 'xs' (12), 'sm' (16), 'md' (20), 'lg' (28).
 */
export default function VerifiedBadge({ size = "sm", className = "", title = "Verified creator" }) {
  const px = { xs: 12, sm: 16, md: 20, lg: 28 }[size] || 16;
  return (
    <span
      data-testid="verified-badge"
      title={title}
      className={`inline-flex items-center justify-center text-papaya ${className}`}
      style={{ width: px + 2, height: px + 2 }}
    >
      <CheckCircle size={px} weight="fill" />
    </span>
  );
}
